import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/sites/$siteId')({
  beforeLoad: ({ context }): void => {
    if (
      context.permissions.isReady &&
      !context.permissions.hasAnyPermission(['sites:manage', 'sites:access-read-only'])
    ) {
      throw redirect({ to: '/settings' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/settings/sites/pages/site-detail-page')),
});
